<template>
  <div>
    <div class="product__heading">
      <router-link v-if="showBackButton" to="/" class="product__back-button">
        <img class="product__back-icon" src="@/assets/images/chevronRight.png">{{ $t('back') }}
      </router-link>
      <h2 class="product__title">
        {{ $t(`global.products.${product.title}.title`) }}
      </h2>
      <div class="product__description">
        {{ $t(`global.products.${product.title}.description`)}}
      </div>
    </div>

    <div class="link-list">
      <link-component
        v-for="link of product.links"
        :key="link.title"
        :link="link"
        :productTitle="product.title"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Product } from '../../reusable/types'
import LinkComponent from './link.vue'
import { config } from '@/setup/config'

@Component({
  components: {
    LinkComponent,
  },
  i18n: {
    messages: {
      en: {
        back: 'Select a project'
      },
      ru: {
        back: 'Выбор продукта'
      }
    }
  }
})
export default class ProductPage extends Vue {
  @Prop({ required: true }) public readonly product!: Product

  get showBackButton () {
    return config.products.length > 1
  }
}
</script>

<style lang="scss" scoped>
.product {
  &__heading {
    position: relative;
    margin-top: 20px;
    display: flex;
    align-items: baseline;
  }
  &__title {
    margin: 0 15px 0 0;
    font-weight: $font-weight-normal;
    font-size: $font-size-display;
    color: $primary;
    letter-spacing: -1px;
  }
  &__description {
    font-size: $font-size-large;
    font-weight: $font-weight-light;
  }
  &__back-button {
    display: inline-flex;
    align-items: center;
    position: absolute;
    transform: translateY(-140%);
    text-decoration: none;
    color: $text-primary;
    &:hover {
      color: black;
    }
  }
  &__back-icon {
    height: 12px;
    margin-right: 7px;
  }
}
</style>